import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanDeleteProvider = (): boolean => {
  const [canDeleteProvider, setCanDeleteProvider] =
    React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const deleteAllPermission: Permission = {
    resource: 'providers',
    action: 'deletebasic',
    scope: 'all',
  };

  const canDeleteAll = useHasPermission(user, deleteAllPermission);

  React.useEffect(() => {
    setCanDeleteProvider(canDeleteAll);
  }, [canDeleteAll]);

  return canDeleteProvider;
};
